import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAdjustments = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	stroke: "currentColor",
	strokeWidth: 2,
	strokeLinecap: "round",
	strokeLinejoin: "round",
	className: "icon icon-tabler icons-tabler-outline icon-tabler-adjustments",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			stroke: "none",
			d: "M0 0h24v24H0z",
			fill: "none"
		}),
		/* @__PURE__ */ _jsx("path", { d: "M4 10a2 2 0 1 0 4 0a2 2 0 0 0 -4 0" }),
		/* @__PURE__ */ _jsx("path", { d: "M6 4v4" }),
		/* @__PURE__ */ _jsx("path", { d: "M6 12v8" }),
		/* @__PURE__ */ _jsx("path", { d: "M10 16a2 2 0 1 0 4 0a2 2 0 0 0 -4 0" }),
		/* @__PURE__ */ _jsx("path", { d: "M12 4v10" }),
		/* @__PURE__ */ _jsx("path", { d: "M12 18v2" }),
		/* @__PURE__ */ _jsx("path", { d: "M16 7a2 2 0 1 0 4 0a2 2 0 0 0 -4 0" }),
		/* @__PURE__ */ _jsx("path", { d: "M18 4v1" }),
		/* @__PURE__ */ _jsx("path", { d: "M18 9v11" })
	]
});
export default SvgAdjustments;
